module.exports = __webpack_public_path__ + "fonts/baronsans-ultrathinitalic-webfont.cf3dfc65.woff2";